/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

export default stubString;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/stubString.js
// module id = 520
// module chunks = 0